<template>
    <div class="purchaseResources_wrap">
        <el-page-header @back="$core.goBack"></el-page-header>
        <div class="position_text"><span>当前位置：</span> 云实验室 > 智能 > <span style="color:#5277F7">进阶版</span></div>
        <div class="purchase_content">
            <el-card>
                <div class="purchase_title">
                    <i class="iconfont icon-goumai"></i><span>&nbsp;资源购买</span>
                </div>
                <div class="resources_cart">
                    <div class="select_title">
                        <el-divider direction="vertical"></el-divider>
                        <span>&nbsp;选择资源</span>
                    </div>
                    <div class="notice">请根据您的计算需求选择合适的资源配置,资源选择并成功支付后不可修改。</div>
                    <div class="resources_list">
                        <div class="row_one">
                            <div @click="selectResources(item.id,item.size)"  v-for="item in resourcesList" :key="item.id" :class="[{'active_resources':item.id == resourcesId},'resources_item']">
                                <div class="cpu_text">CPU</div>
                                <div class="params_wrap">
                                    <div>{{item.parameter}}</div>
                                    <div>{{item.type}}</div>
                                </div>
                                <div class="capacity">默认磁盘容量{{item.size}}G</div>
                            </div>
                        </div>
                        <div class="row_two">
                            <div :class="[{'active_resources':resourcesId == 3},'resources_item']" @click="selectResources(3,20)">
                                <div class="cpu_text" style="background:#F78F52">CPU</div>
                                <div class="params_wrap">
                                    <div>T4 Tenaor Core GPU</div>
                                </div>
                                <div class="capacity">默认磁盘容量20G</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resources_cart">
                    <div class="select_title">
                        <el-divider direction="vertical"></el-divider>
                        <span>参数配置</span>
                    </div>
                    <div class="config_wrap">
                        <div class="flex-start">
                            <span>磁盘容量：</span>
                            <el-input type="number" v-model="diskVolumn"></el-input>&nbsp;(G)
                        </div>
                        <div class="flex-start">
                            <span>时长选择：</span>
                            <el-input type="number" v-model="resourseTime"></el-input>&nbsp;(分钟)
                        </div>
                    </div>
                    <div class="notice_text">注：请按需选择时长，您可在时长结束前随时补充时长。购买成功后，未用完的时长无法退还。</div>
                    <div class="button_wrap">
                        <el-button type="primary" @click="purchaseResources">确认购买</el-button>
                    </div>
                </div>
                <div></div>
            </el-card>
        </div>
        <div class="purchase_content">
            <el-card>
                <div class="purchase_title">
                    <i class="iconfont icon-ziyuanshiyong"></i><span>&nbsp;资源使用</span>
                </div>
                <div class="resources_cart">
                    <div class="select_title">
                        <el-divider direction="vertical"></el-divider>
                        <span>&nbsp;资源详情</span>
                    </div>
                    <div class="resources_list">
                        <div class="purchase_wrap">
                            <el-table :data="purchaseList" border stripe :header-cell-style="$core.tableHeader" header-align="center">
                                <el-table-column align="center" width="120"  label="序号" type="index"></el-table-column>
                                <el-table-column prop="name" align="center" label="可使用资源名称"></el-table-column>
                                <el-table-column prop="type" align="center" label="资源类型"></el-table-column>
                                <el-table-column prop="surplus" align="center" label="剩余可用时长(分钟)"></el-table-column>
                                <el-table-column align="center" label="补充时长(分钟)">
                                    <div slot-scope="scope" class="flex-center">
                                        <el-input type="number" placeholder="请输入想要补充的分钟数" v-model="scope.row.plus"></el-input>
                                        <el-button type="primary" @click="supplyTime(scope.row.plus)" >补充</el-button>
                                    </div>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="purchase_content">
            <el-card>
                <div class="purchase_title">
                    <i class="iconfont icon-ziyuanshiyong"></i><span>&nbsp;资源购买记录</span>
                </div>
                <div class="order_list">
                    <div class="order_item" v-for="i in 4" :key="i">
                        <div class="order_title">
                            <div class="order_name">4核16G CPU资源</div>
                            <div>已完成订单</div>
                        </div>
                        <div class="order_config_wrap">
                            <div><span>资源类型：</span>cpu</div>
                            <div class="flex-between">
                                <div><span>磁盘总容量：</span>无</div>
                                <div><span>订单号：</span>1327188888</div>
                            </div>
                            <div class="flex-between">
                                <div><span>时长(分钟)：</span>60</div>
                                <div><span>支付日期：</span>2021-10-01 13:09:09</div>
                            </div>
                        </div>
                        <div class="order_money"><span>支付金额：</span>137.00</div>
                    </div>
                </div>
                <div class="select_page">
                    <el-pagination  layout="prev, pager, next"  :total="50"></el-pagination>
                </div>
            </el-card>
        </div>
        
        <!-- 补充资源弹窗 -->
        <el-dialog :visible.sync="supplyVisible" width="35%" class="purchase_dialog">
            <div class="purchase_title">
                <i class="iconfont icon-goumai"></i>
                <span>&nbsp;计算资源时长补充</span>
            </div>
            <div class="purchase_list">
                <div><span>计算资源名称：</span>4核16G CPU资源</div>
                <div><span>时长添加(分钟)：</span>20</div>
            </div>
            <div class="purchase_button">
                <el-button type="primary" @click="QRcodeVisible = true;supplyVisible = false">确认补充</el-button>
            </div>
        </el-dialog>

        <!-- 购买资源信息 -->
        <el-dialog :visible.sync="purchaseVisible" width="35%" class="purchase_dialog">
            <div class="purchase_title">
                <i class="iconfont icon-goumai"></i>
                <span>&nbsp;计算资源购买信息</span>
            </div>
            <div class="purchase_list">
                <div><span>总时间：</span>20</div>
                <div><span>磁盘总容量：</span>20G</div>
                <div><span>计算资源名称：</span>4核16G CPU资源</div>
                
            </div>
            <div class="purchase_notice">
                注：请按需选择时长，您可在时长结束前随时补充时长。购买成功后，未用完的时长无法退还。
            </div>
            <div class="purchase_button">
                <el-button type="primary" @click="QRcodeVisible = true;purchaseVisible = false">确认购买</el-button>
            </div>
        </el-dialog>

        <!-- 支付金额二维码 -->
        <el-dialog :visible.sync="QRcodeVisible" width="35%" class="QRcode_wrap">
            <div class="money_wrap">
                <div>需支付金额为</div>
                <div class="require_money">129元</div>
            </div>
            <div class="img_wrap">
                <div>
                    <img src="../../../assets/img/QRcode.png" alt="">
                </div>
                <div class="scan_text">请扫描上方二维码进行支付</div>
            </div>
            <div class="resources_list">
                <div><span>计算资源名称：</span>4核16G CPU资源</div>
                <div><span>磁盘总容量：</span>20G</div>
                <div><span>总时长：</span>20分钟</div>
            </div>
        </el-dialog>

        <!-- 资源支付成功回调 -->
        <el-dialog :visible.sync="purchaseSuccessVisible" width="35%" class="success_wrap">
            <div class="icon_wrap">
                <i class="el-icon-success"></i>
                <span>&nbsp;&nbsp;购买成功！完成支付129元</span>
            </div>
            <div class="resources_list">
                 <div><span>计算资源名称：</span>4核16G CPU资源</div>
                 <div><span>磁盘总容量：</span>20G</div>
                 <div><span>总时长：</span>20分钟</div>
            </div>
            <div>
                <el-button type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                purchaseSuccessVisible:false,
                purchaseVisible:false,
                QRcodeVisible:false,
                supplyVisible:false,
                purchaseList:[{
                    name:'4核16G CPU资源',
                    type:'CPU',
                    surplus:20,
                    plus:''
                }],
                diskVolumn:10,
                resourseTime:0,
                resourcesList:[{
                    id:0,
                    parameter:'8核32G',
                    type:'CPU专业版',
                    size:10
                },{
                    id:1,
                    parameter:'4核16G',
                    type:'CPU专业版',
                    size:5
                },{
                    id:2,
                    parameter:'2核8G',
                    type:'基础资源',
                    size:5
                }],
                resourcesId:0,
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
         
        },
        methods: {
            //购买资源
            purchaseResources(){
                if(!this.diskVolumn) return this.$message.error('请输入磁盘容量！！')
                if(!this.resourseTime) return this.$message.error('请输入所需资源时间！！')
                this.purchaseVisible = true 
            },

            //补充时长
            supplyTime(time){
                if(!time) return this.$message.error("请输入要补充的时长！！")
                this.supplyVisible = true 
            },

            //更改选择资源
            selectResources(id,size){
                this.resourcesId = id,
                this.diskVolumn = size
            }
            
        }
    }
</script>

<style lang="scss" scoped>
.success_wrap{
    text-align: center;
    .icon_wrap{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 23px;
        font-weight: bold;
        i{
            font-size: 40px;
            color: #01B843;
        }
    }
    .resources_list{
        box-sizing: border-box;
        padding: 20px 0px 20px 200px;
        text-align: left;
        >div{
            font-size: 19px;
            margin-bottom: 15px;
            font-weight: bold;
            span{
                color: #999
            }
        }
    }
}
.QRcode_wrap{
    text-align: center;
    .resources_list{
        box-sizing: border-box;
        text-align: left;
        padding: 20px 0px 10px 30%;
        font-size: 16px;
        color:#999;
        div{
            margin: 10px 0px;
        }
    }
    .img_wrap{
        color:#999;
        img{
            width: 200px;
        }
        .scan_text{
            line-height: 1.8;
            margin: 5px 0px;
            
        }
    }
    .money_wrap{
        padding: 10px 0px;
        font-size: 18px;
        font-weight: bold;
        color: black;
        line-height: 1.7;
        .require_money{
            font-size: 25px;
            color:#FF5208;
        }
        
    }
}
.purchase_dialog{
    /deep/.el-dialog__body{
        padding: 0px 30px 20px 30px;
        .purchase_list{
            box-sizing: border-box;
            padding: 40px 80px;
            >div{
                font-size: 20px;
                margin-bottom: 18px;
                font-weight: bold;
                color: #333;
                span{
                    color: #999;
                    width: 200px;
                }
            }
        }
        .purchase_notice{
            // height: 40px;
            font-size: 16px;
            padding: 0px 50px;
            line-height: 1.8;
            margin-bottom: 20px;
            color: #FF0000;
        }
        .purchase_button{
            text-align: center;
        }
        .purchase_title{
            color: #5277F7;
            font-weight: bold;
            height: 50px;
            text-align: center;
            font-size: 25px;
            border-bottom: 2px solid #5277F7;
            i{
                font-size: 25px;
            }
        }
    }
}
.select_page{
    text-align: center;
    /deep/.number{
        font-size: 18px;
    }
}
.order_list{
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 20px 80px;
    .order_item{
        width: 47%;
        border: 1px solid #CFCFCF;
        padding: 25px;
        margin-bottom: 20px;
        box-sizing: border-box;
        .order_title{
            color: #999;
            font-weight: bold;
            height: 40px;
            align-items: center;
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            .order_name{
                color: #5277F7;
                font-size: 25px;
            }
        }
        .order_config_wrap{
            color: #333;
            font-size: 18px;
            padding: 10px 0px;
            font-weight: bold;
            span{
                font-weight: 300;
            }
            >div{
                display: flex;
                height: 35px;
                line-height: 35px;
                >div{
                    width: 50%;
                    
                }
                
            }
        }
        .order_money{
            text-align: right;
            height: 30px;
            line-height: 30px;
            font-size: 22px;
            font-weight: bold;
            span{
                font-weight: 300;
                font-size: 18px;
            }
        }
    }
    
}
.purchase_wrap{
    display: flex;
}
.config_wrap{
    div{
        margin: 10px 0px;
        align-items: center;
        .el-input{
            width: 200px;
        }
    }
    
}
.resources_detail{
    display: flex;
    margin-bottom: 15px;
    >div{
        width: 280px;
        font-size: 20px;
        font-weight: bold;
        color: #999;
    }
}
/deep/.el-card__body{
    box-sizing: border-box;
    padding: 40px 65px;
    
}
/deep/.el-card{
    margin-bottom: 50px;
}
.resources_cart{
    color: #333;
    .notice_text{
        color: #FF0000;
        opacity: 0.8;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
    }
    .notice{
        @extend .notice_text;
        color:#333
    }
    .button_wrap{
        text-align: right;
        margin: 20px;
        box-sizing: border-box;
        padding-right: 50px;
    }
}
.purchase_content{
    box-sizing: border-box;
    padding: 0px 150px;
    .resources_list{
        box-sizing: border-box;
        padding: 20px 172px;
        .row_one{
            justify-content: space-between;
            display: flex;
        }
        .resources_item{
                width: 350px;
                height: 154px;
                box-shadow: 0px 2px 2px #D6D6D6;
                border-radius: 10px;
                overflow: hidden;
                margin-bottom: 34px;
                .cpu_text{
                    width: 100px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    color: white;
                    font-size: 18px;
                    background: #5277F7;
                }
                .params_wrap{
                    padding: 15px 76px;
                    font-size: 20px;
                    font-weight: bold;
                    display: flex;
                    justify-content: space-between;
                }
                .capacity{
                    font-size: 18px;
                    padding: 5px 76px;
                    color: #999;
                }
        }
         .active_resources{
            border: 1px solid #5277F7;
            box-shadow: 0px 4px 4px #D6D6D6;
        }
        .resources_item:hover{
            cursor: pointer;
            border: 1px solid #5277F7;
            box-shadow: 0px 4px 4px #D6D6D6;
        }
    }
    .select_title{
        height: 50px;
        line-height: 50px;
        color: #333;
        font-size: 22px;
        font-weight: bold;
        .el-divider{
            position: relative;
            top: -3px;
            height: 25px;
            background: #5277F7;
            width: 5px;
        }
    }
    .purchase_title{
        font-size: 24px;
        height: 60px;
        line-height: 60px;
        font-weight: bold;
        color: #5277F7;
        i{
            font-size: 24px;
        }
    }
}
.position_text{
    height: 100px;
    padding-left: 200px;
    box-sizing: border-box;
    font-size: 20px;
    line-height: 100px;
    span:first-child{
        font-weight: bold;
    }
}
.purchaseResources_wrap{
    position: relative;
    padding:60px 0px;
    background: #F9F9FF;
    box-sizing: border-box;
}
</style>